// Selectors
const SELECTORS = {
    FORM: '#schufa-check',
    FILE_INPUT: '#fileInput',
    SUBMIT_BUTTON: '#schufa-check [type="submit"]'
};

class ApiSchufa {
    constructor() {
        this._loading = false; // Internal loading state
        this.onLoadingChange = null; // Callback for loading state changes

        this.authorizationHeader = this.generateAuthorizationHeader();
        // Absolute path (from myajax, localized in functions.php via get_stylesheet_directory_uri())
        // rather than a relative "../" path - a relative path breaks once the current URL is
        // nested more than one segment deep, since "../" only pops a single path segment
        // instead of resolving back to the site root.
        this.proxyUrl = (typeof myajax !== 'undefined' && myajax.proxy_url) || '../wp-content/themes/gruuun-theme/api-proxi.php';
        this.initializeEventListeners();
        this.validateForm();
    }

    initializeEventListeners() {
        // Handle file input changes
        $(document).on('change', SELECTORS.FILE_INPUT, (e) => this.handleInputValidation(e));

        // Handle form submission
        $(document).on('submit', SELECTORS.FORM, (e) => this.handleFileUpload(e, $(SELECTORS.FILE_INPUT)));

        // Set callback for loading state changes
        this.onLoadingChange = (isLoading) => {
            if (isLoading) {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', true).addClass('-loading');
            } else {
                $(SELECTORS.SUBMIT_BUTTON).prop('disabled', false).removeClass('-loading');
            }
        };
    }

    // Getter for loading state
    get loading() {
        return this._loading;
    }

    // Setter for loading state with additional logic
    set loading(value) {
        if (this._loading !== value) {
            this._loading = value;
            // Trigger callback if defined
            if (typeof this.onLoadingChange === "function") {
                this.onLoadingChange(value);
            }
        }
    }

    validateForm() {
        // Setup validation messages
        this.setupValidationMessages();

        // Initialize form validation
        this.setupFormValidation();
    }

    setupValidationMessages() {
        // Custom validation messages
        $.extend($.validator.messages, {
            required: "Dieses Feld wird benötigt.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            number: "Bitte geben Sie eine gültige Zahl ein.",
            range: $.validator.format("Bitte geben Sie einen Wert zwischen {0} und {1} ein."),
            max: $.validator.format("Bitte geben Sie einen Wert kleiner oder gleich {0} ein."),
            min: $.validator.format("Bitte geben Sie einen Wert größer oder gleich {0} ein."),
            digits: "Nur Zahlen sind erlaubt.",
            rangelength: $.validator.format("Bitte geben Sie genau {0} Zeichen ein."),
        });
    }

    setupFormValidation() {
        // Configure jQuery validation
        $(SELECTORS.FORM).validate({
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.field-wrap').find('.nf-error-msg'));
            },
            highlight: function (element) {
                $(element).closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
            },
            unhighlight: function (element) {
                $(element).closest('.field-wrap').removeClass('nf-error');
            },
            success: function (label, element) {
                $(element).closest('.field-wrap').addClass('nf-pass');
            },
        });
    }

    handleInputValidation(event) {
        // Validate the specific field
        let $input = $(event.currentTarget);
        $(SELECTORS.FORM).validate().element($input[0]);
    }

    handleFileUpload(event, fileInput) {
        event.preventDefault();

        if (this.loading) {
            return; // Prevent duplicate submissions
        }
        this.loading = true;

        const file = fileInput[0].files[0];
        if (!file) {
            alert("Please upload a .csv file");
            this.loading = false;
            return;
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (fileExtension !== "csv") {
            alert("Unsupported file format. Please upload a .csv file.");
            this.loading = false;
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("action", "upload_csv_file"); // AJAX action name for WordPress
        formData.append("nonce", myajax.nonces.upload_csv_file); // CSRF protect

        // Upload the file to the server
        $.ajax({
            url: myajax.url, // WordPress AJAX URL
            method: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                if (response.success && response.data.filePath) {
                    // console.log("File uploaded successfully:", response.data.filePath);
                    this.processCSVFile(response.data.filePath);
                } else {
                    console.error("File upload failed:", response.data.message || "Unknown error");
                }
            },
            error: (xhr, status, error) => {
                console.error("File upload error:", error);
            }
        });
    }

    processCSVFile(filePath) {
        $.ajax({
            url: myajax.url, // WordPress AJAX URL
            method: "POST",
            data: {
                action: "process_and_download_csv",
                filePath: filePath,
                nonce: myajax.nonces.process_and_download_csv // CSRF protect
            },
            xhrFields: {
                responseType: 'blob' // Expect a blob response
            },
            success: (response) => {
                // Create a blob URL for the response
                const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);

                // Create a temporary link to trigger the download
                const a = document.createElement("a");
                a.href = url;
                a.download = "processed_data.csv";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                // Revoke the object URL after download
                window.URL.revokeObjectURL(url);

                setTimeout(() => this.loading = false, 5);
            },
            error: (xhr, status, error) => {
                alert("Failed to process and download the file. Please try again.");
            }
        });
    }

    generateAuthorizationHeader() {
        const encodedCredentials = btoa(`${this.username}:${this.password}`);
        return `Basic ${encodedCredentials}`;
    }
}

// Initialize API service
export const apiSchufa = new ApiSchufa();

$(document).ready(function () {
    $('#fileInput').filer({
        showThumbs: true,
        addMore: false,
        allowDuplicates: false,
        limit: 1
    });
});